import {
  Flex,
  Heading,
  FormLabel,
  Select,
  Alert,
  AlertIcon,
  FormControl,
  useAccordion,
} from "@chakra-ui/react";
import { useState } from "react";
import { useAppContext } from "../context/appContext/appContext";
import { FormInput, Logo, UIAlert } from "../components";
import { useNavigate } from "react-router-dom";
import { useGameContext } from "../context/gameContext/gameContext";

import styled from "styled-components";

const GameSettings = () => {
  const { showAlert, displayAlert, user, gs } = useAppContext();
  const { setupGameSettings } = useGameContext();

  const initialState = {
    gameMode: "2v2 Teams",
    numPlayers: "4",
    username: user?.name || "",
    winningScore: "11",
  };

  const [values, setValues] = useState(initialState);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  // Number of Players is only valid within the range each Game Mode
  // supports, so a Game Mode change has to reset it to that mode's
  // default rather than leaving behind a value the new mode doesn't offer
  // (e.g. "3" surviving a switch back to 2v2 Teams, which only ever has 4).
  const handleGameModeChange = (e) => {
    const gameMode = e.target.value;
    setValues({
      ...values,
      gameMode,
      numPlayers: gameMode === "Cutthroat" ? "3" : "4",
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const { gameMode, numPlayers, username, winningScore } = values;
    if (!gameMode || !numPlayers || !username || !winningScore) {
      displayAlert();
      return;
    }

    if (username.length > 20) {
      displayAlert();
    }

    const specificGameValues = {
      gameMode,
      numPlayers,
      username,
      winningScore,
    };
    setupGameSettings(specificGameValues);
    setValues(initialState);
    gs();
    navigate("/play/play-game");
  };

  return (
    <Flex justify="center" align="center" mt={10}>
      <Wrapper>
        <form className="form" onSubmit={onSubmit}>
          <Logo
            image={"apple-touch-icon.png"}
            size={"50px"}
            color={"#63aab5"}
          />
          {showAlert && <UIAlert />}
          <Heading as="h2" size="lg" color="headline.400" fontStyle="italic">
            Game Settings
          </Heading>
          <Flex direction="column" gap="20px" width="100%">
            <FormControl width="100%" maxW="300px" mx="auto">
              <FormLabel color="headline.400" fontWeight="bold">
                Game Mode
              </FormLabel>
              <Select
                value={values.gameMode}
                w="100%"
                maxW={"300px"}
                name="gameMode"
                onChange={handleGameModeChange}
              >
                <option value="2v2 Teams">2v2 Teams (You + 3 Bots)</option>
                <option value="Cutthroat">Cutthroat</option>
              </Select>
            </FormControl>
            {values.gameMode === "Cutthroat" ? (
              <FormControl width="100%" maxW="300px" mx="auto">
                <FormLabel color="headline.400" fontWeight="bold">
                  Number of Players
                </FormLabel>

                <Select
                  w="100%"
                  maxW={"300px"}
                  name="numPlayers"
                  onChange={handleChange}
                  value={values.numPlayers}
                >
                  <option>3</option>
                  <option>4</option>
                </Select>
              </FormControl>
            ) : (
              <FormInput
                inputType="input"
                name="numPlayers"
                handleChange={handleChange}
                value={values.numPlayers}
                readOnly={true}
                labelText="Number of Players"
              />
            )}
            <FormControl width="100%" maxW="300px" mx="auto">
              <FormLabel color="headline.400" fontWeight="bold">
                Winning Score
              </FormLabel>
              <Select
                w="100%"
                maxW={"300px"}
                name="winningScore"
                onChange={handleChange}
                value={values.winningScore}
              >
                <option>11</option>
                <option>15</option>
                <option>21</option>
              </Select>
            </FormControl>
          </Flex>
          {values.username.length > 20 && (
            <Alert status="error">
              <AlertIcon />
              Username cannot be more than 20 characters
            </Alert>
          )}
          <FormInput
            inputType="input"
            name="username"
            value={values.username}
            labelText="Username"
            handleChange={handleChange}
          />

          <button className="form-btn" bg="headline.400" color="white">
            Play Game
          </button>
        </form>
      </Wrapper>
    </Flex>
  );
};
export default GameSettings;

const Wrapper = styled.section`
  padding: 0 16px;
  box-sizing: border-box;

  .form {
    min-height: 400px;
    background-color: white;
    border: 3px solid #63aab5;
    margin: 0 auto;
    width: min(90vw, 600px);
    display: flex;
    box-sizing: border-box;
    align-items: center;
    border-radius: 5px;
    flex-direction: column;
    padding: clamp(16px, 5vw, 20px);
    gap: 20px;
  }

  .form-btn {
    width: min(180px, 100%);
    margin: 5px;
    margin-top: 10px;
    cursor: pointer;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    background-color: #63aab5;
    border: none;
    padding: 5px;
  }

  .form-btn:hover {
    background-color: #4a919c;
  }
`;
